import { AuthenticationService } from '@core/services';
import { LocaleService } from '@selfcare/cms';
import { Store } from '@ngrx/store';
import { UserActions, userFeature } from '@state';
import { forkJoin, of } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AppRouting } from './enums';

export function initializeApp(
  localeService: LocaleService,
  store: Store,
  authService: AuthenticationService
) {
  const path = window.location.pathname;

  if (authService.isAuthorized && !path.includes(`/${AppRouting.ResetPassword}`)) {
    store.dispatch(UserActions.getUserDetails());

    const user$ = store.select(userFeature.selectCurrent).pipe(
      filter((user) => !!user),
      take(1)
    );

    return () => forkJoin([localeService.initializeLocalization(), user$]);
  }

  return () => forkJoin([localeService.initializeLocalization(), of(true)]);
}
